import {
  GetAllActivitiesByGroup,
  GetAllActivitiesByPlace,
  GetAllActivitiesByStatus,
  GetAllActivitiesByStudent,
  GetAllActivitiesByTask,
  GetCompletedAndMissedActivitiesCount,
  GetActivitiesInProgressCount,
  GetAllCHMetrics,
  GetAllUsersMetrics,
  GetSummaryProfile,
  GetActivityByStatus,
  GetMapActivitiesMarkers,
  GetMapInternshipMarkers,
  GetMapActivityDetails,
} from 'domain/usecases';

export class DashboardService {
  constructor(
    private readonly _getAllActivitiesByGroupUseCase: GetAllActivitiesByGroup,
    private readonly _getAllActivitiesByPlaceUseCase: GetAllActivitiesByPlace,
    private readonly _getAllActivitiesByTaskUseCase: GetAllActivitiesByTask,
    private readonly _getAllActivitiesByStatusUseCase: GetAllActivitiesByStatus,
    private readonly _getAllActivitiesByStudentUseCase: GetAllActivitiesByStudent,
    private readonly _getAllCHMetricsUseCase: GetAllCHMetrics,
    private readonly _getAllUsersMetricsUseCase: GetAllUsersMetrics,
    private readonly _getCompletedAndMissedActivitiesCountUseCase: GetCompletedAndMissedActivitiesCount,
    private readonly _getActivitiesInProgressCountUseCase: GetActivitiesInProgressCount,
    private readonly _getSummaryProfileUseCase: GetSummaryProfile,
    private readonly _getActivityByStatusUseCase: GetActivityByStatus,
    private readonly _getMapActivitiesMarkersUseCase: GetMapActivitiesMarkers,
    private readonly _getMapInternshipMarkersUseCase: GetMapInternshipMarkers,
    private readonly _getMapActivityDetailsUseCase: GetMapActivityDetails,
  ) {}

  async getAllActivitiesByGroup(
    params: GetAllActivitiesByGroup.Params,
  ): Promise<GetAllActivitiesByGroup.Result> {
    return await this._getAllActivitiesByGroupUseCase.execute(params);
  }

  async getSummaryProfile(
    params: GetSummaryProfile.Params,
  ): Promise<GetSummaryProfile.Result> {
    return await this._getSummaryProfileUseCase.execute(params);
  }

  async getAllActivitiesByPlace(
    params: GetAllActivitiesByPlace.Params,
  ): Promise<GetAllActivitiesByPlace.Result> {
    return await this._getAllActivitiesByPlaceUseCase.execute(params);
  }

  async getAllActivitiesByTask(
    params: GetAllActivitiesByTask.Params,
  ): Promise<GetAllActivitiesByTask.Result> {
    return await this._getAllActivitiesByTaskUseCase.execute(params);
  }

  async getAllActivitiesByStatus(
    params: GetAllActivitiesByStatus.Params,
  ): Promise<GetAllActivitiesByStatus.Result> {
    return await this._getAllActivitiesByStatusUseCase.execute(params);
  }

  async getAllActivitiesByStudent(
    params: GetAllActivitiesByStudent.Params,
  ): Promise<GetAllActivitiesByStudent.Result> {
    return await this._getAllActivitiesByStudentUseCase.execute(params);
  }

  async getAllCHMetrics(
    params: GetAllCHMetrics.Params,
  ): Promise<GetAllCHMetrics.Result> {
    return await this._getAllCHMetricsUseCase.execute(params);
  }

  async getAllUsersMetrics(
    params: GetAllUsersMetrics.Params,
  ): Promise<GetAllUsersMetrics.Result> {
    return await this._getAllUsersMetricsUseCase.execute(params);
  }

  async getCompletedAndMissedActivitiesCount(
    params: GetCompletedAndMissedActivitiesCount.Params,
  ): Promise<GetCompletedAndMissedActivitiesCount.Result> {
    return await this._getCompletedAndMissedActivitiesCountUseCase.execute(
      params,
    );
  }

  async getActivitiesInProgressCount(
    params: GetActivitiesInProgressCount.Params,
  ): Promise<GetActivitiesInProgressCount.Result> {
    return await this._getActivitiesInProgressCountUseCase.execute(params);
  }

  async getActivitiesByStatus(
    params: GetActivityByStatus.Params,
  ): Promise<GetActivityByStatus.Result> {
    return await this._getActivityByStatusUseCase.execute(params);
  }

  async getMapActivitiesMarkers(
    params: GetMapActivitiesMarkers.Params,
  ): Promise<GetMapActivitiesMarkers.Result> {
    return await this._getMapActivitiesMarkersUseCase.execute(params);
  }

  async getMapInternshipMarkers(
    params: GetMapInternshipMarkers.Params,
  ): Promise<GetMapInternshipMarkers.Result> {
    return await this._getMapInternshipMarkersUseCase.execute(params);
  }

  async getMapActivityDetails(
    params: GetMapActivityDetails.Params,
  ): Promise<GetMapActivityDetails.Result> {
    return await this._getMapActivityDetailsUseCase.execute(params);
  }
}
